import {
  NotificationsByFilterPayload,
  NotificationsResult,
} from 'apps/orion/src/app/features/scm/material-management/v1/store/global-notifications/global-notifications.types';
import { Plant } from '../configuration';
import { UserRights } from './authenticated-user.model';
import { AuthenticationAction } from './authentication.types';

export class AppInitDone {
  static readonly type = AuthenticationAction.APP_INIT_DONE;
}

export class LoginApplicationDomain {
  static readonly type = AuthenticationAction.LOGIN_APPLICATION_DOMAIN;
  constructor(
    public readonly domain: string,
    public readonly username: string,
    public readonly password: string,
    public readonly plant: string,
  ) {}
}

export class LoginApplicationTest {
  static readonly type = AuthenticationAction.LOGIN_APPLICATION_TEST;
  constructor(public readonly username: string) {}
}

export class LoginSuccessDomain {
  static readonly type = AuthenticationAction.LOGIN_SUCCESS_DOMAIN;
  constructor(
    public readonly token: string,
    public readonly plant: string,
    public readonly username: string,
  ) {}
}

export class LoginErrorDomain {
  static readonly type = AuthenticationAction.LOGIN_ERROR_DOMAIN;
}

export class LoadConfig {
  static readonly type = AuthenticationAction.LOAD_CONFIG;
}

export class LoadConfigSuccess {
  static readonly type = AuthenticationAction.LOAD_CONFIG_SUCCESS;
  constructor(public readonly plants: Plant[]) {}
}

export class LoadConfigError {
  static readonly type = AuthenticationAction.LOAD_CONFIG_ERROR;
  constructor(public readonly error: unknown) {}
}

export class LoginAdfs {
  static readonly type = AuthenticationAction.LOGIN_ADFS;
}

export class LoginAdfsSuccess {
  static readonly type = AuthenticationAction.LOGIN_ADFS_SUCCESS;
  constructor(
    public readonly username: string | undefined,
    public readonly upn: string | undefined,
    public readonly primarySid: string | undefined,
  ) {}
}

export class LogoutAdfs {
  static readonly type = AuthenticationAction.LOGOUT_ADFS;
}

export class FetchAdfsPlants {
  static readonly type = AuthenticationAction.FETCH_ADFS_PLANTS;
}

export class SetActivePlant {
  static readonly type = AuthenticationAction.SET_ACTIVE_PLANT;
  constructor(public readonly plant: string) {}
}

export class SetTenant {
  static readonly type = AuthenticationAction.SET_TENANT;
  constructor(public readonly tenant: string) {}
}

export class SetUserRights {
  static readonly type = AuthenticationAction.SET_USER_RIGHTS;
  constructor(public readonly userRights: UserRights) {}
}

export class SetUserRightsSuccess {
  static readonly type = AuthenticationAction.SET_USER_RIGHTS_SUCCESS;
  constructor(public readonly userRights: UserRights) {}
}

export class SetLoading {
  static readonly type = AuthenticationAction.SET_LOADING;
  constructor(public readonly loading: boolean) {}
}

export class SetUserRightsByRole {
  static readonly type = AuthenticationAction.SET_USER_RIGHTS_BY_ROLE;
}

export class SetManageCommitsRights {
  static readonly type = AuthenticationAction.SET_MANAGE_COMMITS_RIGHTS;
  constructor(public readonly permission: boolean) {}
}

export class SetUserRole {
  static readonly type = AuthenticationAction.SET_USER_ROLE;
  constructor(public readonly role: string) {}
}

export class SetUserRoles {
  static readonly type = AuthenticationAction.SET_USER_ROLES;
  constructor(public readonly roles: string[]) {}
}

export class GetGlobalNotificationsByFilter {
  static readonly type = AuthenticationAction.GET_GLOBAL_NOTIFICATIONS_BY_FILTER;
  constructor(public readonly filter: NotificationsByFilterPayload) {}
}

export class GetGlobalNotificationsByFilterSuccess {
  static readonly type = AuthenticationAction.GET_GLOBAL_NOTIFICATIONS_BY_FILTER_SUCCESS;
  constructor(public readonly notifications: NotificationsResult) {}
}

export class GetGlobalNotificationsByFilterError {
  static readonly type = AuthenticationAction.GET_GLOBAL_NOTIFICATIONS_BY_FILTER_ERROR;
  constructor(public readonly error: unknown) {}
}
